import { OPTIMIZELY_FEATURE_FLAGS_KEYS, SCHEDULE_DETAILS_V2 } from 'components/Optimizely/Optimizely.features';

import { useIsScheduleV2FeatureEnabled } from './useIsScheduleV2FeatureEnabled';

const VENUE_ATTRIBUTE = 'active_venue_id';

export function useIsScheduleDetailsV2Enabled(venueId) {
  return useIsScheduleV2FeatureEnabled(OPTIMIZELY_FEATURE_FLAGS_KEYS[SCHEDULE_DETAILS_V2], {
    [VENUE_ATTRIBUTE]: venueId,
  });
}
